// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/Fredoka-Variable.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../font/NunitoSans-Variable.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Fredoka (headings, player names, popup text) and Nunito Sans (instructions,
 * labels, body copy). Both are the Google Fonts variable versions, subset to
 * Latin with only the weight axis kept, so each is ~30 KB.
 */
@font-face {
  font-family: 'Fredoka';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  font-weight: 300 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Nunito Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
  font-weight: 200 1000;
  font-style: normal;
  font-display: swap;
}

:root {
  /* Palette */
  --navy: #17357f;
  --navy-deep: #0e2463;
  --ink: #142a66;
  --ink-soft: rgba(20, 42, 102, 0.72);
  --ink-faint: rgba(20, 42, 102, 0.16);
  --sky: #b4e3fb;
  --sky-strong: #7fd2f7;
  --sky-soft: #dbeafb;
  --blue: #38b6f5;
  --blue-soft: #a9dbf7;
  --pink: #f06ea3;
  --pink-soft: #f6b3cd;
  --white: #ffffff;
  --paper: rgba(255, 255, 255, 0.6);
  --disabled: #a7b4d3;

  /* Legacy names, kept so older rules keep working. */
  --primary-background: var(--sky-soft);
  --secondary-background: var(--white);
  --primary-color: var(--ink);
  --secondary-color: var(--pink);
  --tertiary-color: var(--sky-strong);
  --other-team-color: var(--blue-soft);
  --team1-panel: var(--blue-soft);
  --team2-panel: var(--pink-soft);
  --team1-text: #1b8ad3;
  --team2-text: #de3f7c;
  --error-color: #e0345f;
  --light-border-color: #c5d6ee;
  --font-border-color: var(--ink);
  --outline-text-shadow: none;

  /* Shape */
  --border-radius: 12px;
  --card-radius: 18px;
  --button-radius: 12px;
  --pill-radius: 999px;
  --shadow-card: 0 2px 6px rgba(14, 36, 99, 0.10);
  --shadow-float: 0 14px 40px rgba(10, 30, 80, 0.28);

  /* Type */
  --font-heading: 'Fredoka', 'Nunito Sans', Arial, Helvetica, sans-serif;
  --font-body: 'Nunito Sans', Arial, Helvetica, sans-serif;
  --font-family: var(--font-body);
  --font-color: var(--ink);
  --secondary-font-color: var(--white);
  --font-size: 16px;
  --input-font-size: 1.2rem;

  /* Layout */
  --global-width: 1200px;
  --card-margin: 1.5rem;
  /* Actual rendered width of the card (it shrinks on narrow windows). */
  --room-width: min(var(--global-width), calc(100vw - 2rem));
  /* Fill the viewport below the 4rem header, but never get cramped. */
  --content-height: max(36rem, calc(100vh - 4rem - 2 * var(--card-margin)));
  --bounce-effect: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

html {
  color: var(--font-color);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: 600;
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: start;
  background: linear-gradient(160deg, #f57fb6, #ec5f97);
  min-height: 100vh;
  overflow-x: hidden;
}

/* Blue half of the diagonal split behind the card. The drift is always
   attached but paused, so the landing page can run it and the split simply
   freezes in place (no snap) when we move into a room. */
body::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(200deg, #5cc8f8, #27a8ef);
  clip-path: polygon(30% 0, 100% 0, 100% 100%, 18% 100%);
  z-index: -1;
  animation: splitDrift 18s ease-in-out infinite paused;
}

body.landingPage::before {
  animation-play-state: running;
}

@keyframes splitDrift {
  0%, 100% {
    clip-path: polygon(30% 0, 100% 0, 100% 100%, 18% 100%);
  }
  50% {
    clip-path: polygon(24% 0, 100% 0, 100% 100%, 22% 100%);
  }
}

svg {
  overflow: visible;
}

h1, h2, h3, h4 {
  font-family: var(--font-heading);
  font-weight: 600;
  color: var(--ink);
  line-height: 1.15;
}

h1 {
  font-size: 2.4rem;
  margin: 0.5rem 0;
}

h2 {
  font-size: 1.7rem;
  margin: 0.6rem 0 0.3rem;
}

h3 {
  font-size: 1.35rem;
  margin: 0.6rem 0 0.3rem;
}

h4 {
  font-size: 1.05rem;
  margin: 0.4rem 0;
}

p {
  margin: 0.3rem 0;
}

/* Text that belongs to the playful heading face. */
.heading {
  font-family: var(--font-heading);
  font-weight: 600;
}

button,
input {
  display: inline-block;
  margin: 0.3rem 0.5rem 0.3rem 0;
  padding: 0 1.5rem;
  height: 3.25rem;
  line-height: 1;
  border: 2px solid var(--light-border-color);
  border-radius: var(--button-radius);
  font-family: var(--font-body);
  font-size: var(--font-size);
  font-weight: 700;
  color: var(--ink);
  background: var(--white);
  box-sizing: border-box;
}

textarea:focus,
button:focus,
input:focus {
  outline: none;
}

input:focus,
textarea:focus {
  border-color: var(--navy);
}

input {
  min-width: 18rem;
  margin-bottom: 1rem;
  font-size: var(--input-font-size);
}

input::placeholder,
textarea::placeholder {
  color: var(--ink-soft);
  font-weight: 600;
}

hr {
  border: 0;
  height: 1px;
  background: var(--ink);
  opacity: 0.25;
  margin: 0.5rem 1rem;
}

@media (max-width: 600px) {
  input {
    min-width: unset;
    display: block;
    width: 100%;
  }
}

button {
  background: var(--navy);
  color: var(--white);
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.25rem;
  letter-spacing: 0.2px;
  border: 2px solid var(--navy);
  box-shadow: 0 3px 0 var(--navy-deep);
  cursor: pointer;
  position: relative;
  top: 0;
  transition: transform 0.08s ease, box-shadow 0.08s ease, background-color 0.15s ease;
}

button:hover:not(:disabled) {
  background: #1d3f96;
  border-color: #1d3f96;
}

button:active:not(:disabled) {
  transform: translateY(3px);
  box-shadow: 0 0 0 var(--navy-deep);
}

button:disabled {
  background: var(--disabled);
  border-color: var(--disabled);
  color: rgba(255, 255, 255, 0.85);
  cursor: default;
  box-shadow: none;
}

button.reverse,
button.back {
  background: var(--white);
  color: var(--ink);
  border: 2px solid var(--navy);
  box-shadow: 0 3px 0 rgba(14, 36, 99, 0.25);
}

button.reverse:hover:not(:disabled),
button.back:hover:not(:disabled) {
  background: #f2f7fd;
  border-color: var(--navy);
}

button.block {
  display: block;
  width: 100%;
  margin: 1rem 0 0.5rem;
  height: 3.75rem;
  font-size: 1.5rem;
}

/* A soft highlight that sweeps across the button every few seconds. */
button.shine {
  overflow: hidden;
}

button.shine::after {
  content: "";
  position: absolute;
  top: 0;
  left: -40%;
  width: 40%;
  height: 100%;
  background: linear-gradient(
    100deg,
    transparent 0%,
    rgba(255, 255, 255, 0.28) 45%,
    transparent 100%
  );
  animation: buttonShine 3.8s ease-in-out 1.2s infinite;
  pointer-events: none;
}

@keyframes buttonShine {
  0%, 55% { transform: translateX(0); }
  80%, 100% { transform: translateX(380%); }
}

/* Shared entrance: rise up and settle with a little bounce. */
@keyframes landIn {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  body::before,
  button.shine::after {
    animation: none;
  }
}

#webapp-root {
  box-sizing: border-box;
  position: relative;
  width: var(--global-width);
  max-width: calc(100vw - 2rem);
  border-radius: var(--card-radius);
  background-color: var(--sky-soft);
  box-shadow: var(--shadow-float);
  overflow: hidden;
  margin: var(--card-margin) 0;
}

@media (max-width: 600px) {
  :root {
    --room-width: 100vw;
  }

  #webapp-root {
    margin: 0;
    max-width: unset;
    border-radius: 0;
    border: none;
    box-shadow: none;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
  }
}

/* ---- Utilities ---- */

.bold {
  font-weight: 800;
}

.big {
  font-size: 2.3rem;
}

.red {
  color: var(--error-color);
}

.center {
  text-align: center;
}

.flex {
  display: flex;
}

.muted {
  color: var(--ink-soft);
}

.logo {
  height: 6rem;
  margin: 0 1rem;
}

/* Small rounded status pill. */
.pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: var(--sky-strong);
  color: var(--ink);
  border-radius: var(--pill-radius);
  padding: 0.35rem 1rem;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.2;
  white-space: nowrap;
}

.pill.light {
  background: var(--white);
}

/* Big rounded status pill with "> text <" chevrons on both sides. */
.chevrons {
  display: inline-flex;
  align-items: center;
  gap: 1rem;
}

.chevrons::before,
.chevrons::after {
  content: "";
  flex-shrink: 0;
  width: 0.42em;
  height: 0.42em;
  border-top: max(2px, 0.11em) solid var(--ink);
  border-right: max(2px, 0.11em) solid var(--ink);
  opacity: 0.9;
}

.chevrons::before {
  transform: rotate(45deg);
}

.chevrons::after {
  transform: rotate(-135deg);
}

.statusPill {
  background: var(--sky-strong);
  color: var(--ink);
  border-radius: var(--pill-radius);
  padding: 0.5rem 1.4rem;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.3rem;
  line-height: 1.2;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Circular initial badge for a player. */
.avatar {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: var(--sky-strong);
  color: var(--ink);
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.2rem;
  text-transform: uppercase;
  line-height: 1;
}

.avatar.pink {
  background: var(--pink-soft);
}

.avatar.team1 {
  background: #5fc0f0;
}

.avatar.team2 {
  background: #e86ca1;
  color: var(--white);
}

.error {
  font-size: 1.1rem;
  position: absolute;
  top: 5rem;
  left: 0;
  right: 0;
  z-index: 10;
  color: var(--error-color);
  text-align: center;
}

.error > span {
  padding: 0.6rem 1.2rem;
  border-radius: var(--border-radius);
  background-color: var(--white);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  display: inline-block;
}

.loadingSpinner {
  position: absolute;
  width: 0;
  height: 0;
  border: 3rem solid var(--navy);
  border-top-color: var(--pink);
  border-bottom-color: var(--pink);
  border-radius: 50%;
  animation: loadingspin 1.4s linear infinite;
  margin: 12rem auto 0;
  left: 0;
  right: 0;
  z-index: 20;
}

@keyframes loadingspin {
  100% {
    transform: rotate(360deg);
  }
}

textarea {
  padding: 0.8rem 1rem;
  min-width: 30rem;
  min-height: 12rem;
  font-family: var(--font-body);
  font-size: var(--input-font-size);
  font-weight: 600;
  color: var(--font-color);
  background: var(--white);
  border: 2px solid var(--light-border-color);
  border-radius: var(--border-radius);
  margin-bottom: 0.4rem;
  resize: vertical;
}

@media (max-width: 600px) {
  textarea {
    display: block;
    box-sizing: border-box;
    min-width: unset;
    width: 100%;
    height: 10rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/global.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,sBAAsB;EACtB,4DAA0D;EAC1D,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4DAA6D;EAC7D,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;;EAEnB,oDAAoD;EACpD,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;EAC3B,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;EACpC,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;;EAE3B,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,+CAA+C;EAC/C,kDAAkD;;EAElD,SAAS;EACT,sEAAsE;EACtE,wDAAwD;EACxD,+BAA+B;EAC/B,wBAAwB;EACxB,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;;EAEzB,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,sEAAsE;EACtE,0DAA0D;EAC1D,oEAAoE;EACpE,yEAAyE;EACzE,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,qDAAqD;EACrD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;yDAEyD;AACzD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qDAAqD;EACrD,sDAAsD;EACtD,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,sDAAsD;EACxD;EACA;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,2CAA2C;EAC3C,mCAAmC;EACnC,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,oFAAoF;AACtF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,iBAAiB;EACjB,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ;;;;;GAKC;EACD,qDAAqD;EACrD,oBAAoB;AACtB;;AAEA;EACE,UAAU,wBAAwB,EAAE;EACpC,YAAY,2BAA2B,EAAE;AAC3C;;AAEA,8DAA8D;AAC9D;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;EACjC,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,wBAAwB;;AAExB;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,iCAAiC;EACjC,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oEAAoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,aAAa;EACb,cAAc;EACd,6CAA6C;EAC7C,+CAA+C;EAC/C,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,iCAAiC;EACjC,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,8BAA8B;EAC9B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;EACpB,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,2CAA2C;EAC3C,mCAAmC;EACnC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":["/*\n * Fredoka (headings, player names, popup text) and Nunito Sans (instructions,\n * labels, body copy). Both are the Google Fonts variable versions, subset to\n * Latin with only the weight axis kept, so each is ~30 KB.\n */\n@font-face {\n  font-family: 'Fredoka';\n  src: url('../font/Fredoka-Variable.woff2') format('woff2');\n  font-weight: 300 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Nunito Sans';\n  src: url('../font/NunitoSans-Variable.woff2') format('woff2');\n  font-weight: 200 1000;\n  font-style: normal;\n  font-display: swap;\n}\n\n:root {\n  /* Palette */\n  --navy: #17357f;\n  --navy-deep: #0e2463;\n  --ink: #142a66;\n  --ink-soft: rgba(20, 42, 102, 0.72);\n  --ink-faint: rgba(20, 42, 102, 0.16);\n  --sky: #b4e3fb;\n  --sky-strong: #7fd2f7;\n  --sky-soft: #dbeafb;\n  --blue: #38b6f5;\n  --blue-soft: #a9dbf7;\n  --pink: #f06ea3;\n  --pink-soft: #f6b3cd;\n  --white: #ffffff;\n  --paper: rgba(255, 255, 255, 0.6);\n  --disabled: #a7b4d3;\n\n  /* Legacy names, kept so older rules keep working. */\n  --primary-background: var(--sky-soft);\n  --secondary-background: var(--white);\n  --primary-color: var(--ink);\n  --secondary-color: var(--pink);\n  --tertiary-color: var(--sky-strong);\n  --other-team-color: var(--blue-soft);\n  --team1-panel: var(--blue-soft);\n  --team2-panel: var(--pink-soft);\n  --team1-text: #1b8ad3;\n  --team2-text: #de3f7c;\n  --error-color: #e0345f;\n  --light-border-color: #c5d6ee;\n  --font-border-color: var(--ink);\n  --outline-text-shadow: none;\n\n  /* Shape */\n  --border-radius: 12px;\n  --card-radius: 18px;\n  --button-radius: 12px;\n  --pill-radius: 999px;\n  --shadow-card: 0 2px 6px rgba(14, 36, 99, 0.10);\n  --shadow-float: 0 14px 40px rgba(10, 30, 80, 0.28);\n\n  /* Type */\n  --font-heading: 'Fredoka', 'Nunito Sans', Arial, Helvetica, sans-serif;\n  --font-body: 'Nunito Sans', Arial, Helvetica, sans-serif;\n  --font-family: var(--font-body);\n  --font-color: var(--ink);\n  --secondary-font-color: var(--white);\n  --font-size: 16px;\n  --input-font-size: 1.2rem;\n\n  /* Layout */\n  --global-width: 1200px;\n  --card-margin: 1.5rem;\n  /* Actual rendered width of the card (it shrinks on narrow windows). */\n  --room-width: min(var(--global-width), calc(100vw - 2rem));\n  /* Fill the viewport below the 4rem header, but never get cramped. */\n  --content-height: max(36rem, calc(100vh - 4rem - 2 * var(--card-margin)));\n  --bounce-effect: cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\nhtml {\n  color: var(--font-color);\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n  font-weight: 600;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  margin: 0;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  background: linear-gradient(160deg, #f57fb6, #ec5f97);\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n/* Blue half of the diagonal split behind the card. The drift is always\n   attached but paused, so the landing page can run it and the split simply\n   freezes in place (no snap) when we move into a room. */\nbody::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(200deg, #5cc8f8, #27a8ef);\n  clip-path: polygon(30% 0, 100% 0, 100% 100%, 18% 100%);\n  z-index: -1;\n  animation: splitDrift 18s ease-in-out infinite paused;\n}\n\nbody.landingPage::before {\n  animation-play-state: running;\n}\n\n@keyframes splitDrift {\n  0%, 100% {\n    clip-path: polygon(30% 0, 100% 0, 100% 100%, 18% 100%);\n  }\n  50% {\n    clip-path: polygon(24% 0, 100% 0, 100% 100%, 22% 100%);\n  }\n}\n\nsvg {\n  overflow: visible;\n}\n\nh1, h2, h3, h4 {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  color: var(--ink);\n  line-height: 1.15;\n}\n\nh1 {\n  font-size: 2.4rem;\n  margin: 0.5rem 0;\n}\n\nh2 {\n  font-size: 1.7rem;\n  margin: 0.6rem 0 0.3rem;\n}\n\nh3 {\n  font-size: 1.35rem;\n  margin: 0.6rem 0 0.3rem;\n}\n\nh4 {\n  font-size: 1.05rem;\n  margin: 0.4rem 0;\n}\n\np {\n  margin: 0.3rem 0;\n}\n\n/* Text that belongs to the playful heading face. */\n.heading {\n  font-family: var(--font-heading);\n  font-weight: 600;\n}\n\nbutton,\ninput {\n  display: inline-block;\n  margin: 0.3rem 0.5rem 0.3rem 0;\n  padding: 0 1.5rem;\n  height: 3.25rem;\n  line-height: 1;\n  border: 2px solid var(--light-border-color);\n  border-radius: var(--button-radius);\n  font-family: var(--font-body);\n  font-size: var(--font-size);\n  font-weight: 700;\n  color: var(--ink);\n  background: var(--white);\n  box-sizing: border-box;\n}\n\ntextarea:focus,\nbutton:focus,\ninput:focus {\n  outline: none;\n}\n\ninput:focus,\ntextarea:focus {\n  border-color: var(--navy);\n}\n\ninput {\n  min-width: 18rem;\n  margin-bottom: 1rem;\n  font-size: var(--input-font-size);\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  color: var(--ink-soft);\n  font-weight: 600;\n}\n\nhr {\n  border: 0;\n  height: 1px;\n  background: var(--ink);\n  opacity: 0.25;\n  margin: 0.5rem 1rem;\n}\n\n@media (max-width: 600px) {\n  input {\n    min-width: unset;\n    display: block;\n    width: 100%;\n  }\n}\n\nbutton {\n  background: var(--navy);\n  color: var(--white);\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.25rem;\n  letter-spacing: 0.2px;\n  border: 2px solid var(--navy);\n  box-shadow: 0 3px 0 var(--navy-deep);\n  cursor: pointer;\n  position: relative;\n  top: 0;\n  transition: transform 0.08s ease, box-shadow 0.08s ease, background-color 0.15s ease;\n}\n\nbutton:hover:not(:disabled) {\n  background: #1d3f96;\n  border-color: #1d3f96;\n}\n\nbutton:active:not(:disabled) {\n  transform: translateY(3px);\n  box-shadow: 0 0 0 var(--navy-deep);\n}\n\nbutton:disabled {\n  background: var(--disabled);\n  border-color: var(--disabled);\n  color: rgba(255, 255, 255, 0.85);\n  cursor: default;\n  box-shadow: none;\n}\n\nbutton.reverse,\nbutton.back {\n  background: var(--white);\n  color: var(--ink);\n  border: 2px solid var(--navy);\n  box-shadow: 0 3px 0 rgba(14, 36, 99, 0.25);\n}\n\nbutton.reverse:hover:not(:disabled),\nbutton.back:hover:not(:disabled) {\n  background: #f2f7fd;\n  border-color: var(--navy);\n}\n\nbutton.block {\n  display: block;\n  width: 100%;\n  margin: 1rem 0 0.5rem;\n  height: 3.75rem;\n  font-size: 1.5rem;\n}\n\n/* A soft highlight that sweeps across the button every few seconds. */\nbutton.shine {\n  overflow: hidden;\n}\n\nbutton.shine::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -40%;\n  width: 40%;\n  height: 100%;\n  background: linear-gradient(\n    100deg,\n    transparent 0%,\n    rgba(255, 255, 255, 0.28) 45%,\n    transparent 100%\n  );\n  animation: buttonShine 3.8s ease-in-out 1.2s infinite;\n  pointer-events: none;\n}\n\n@keyframes buttonShine {\n  0%, 55% { transform: translateX(0); }\n  80%, 100% { transform: translateX(380%); }\n}\n\n/* Shared entrance: rise up and settle with a little bounce. */\n@keyframes landIn {\n  from {\n    opacity: 0;\n    transform: translateY(16px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  body::before,\n  button.shine::after {\n    animation: none;\n  }\n}\n\n#webapp-root {\n  box-sizing: border-box;\n  position: relative;\n  width: var(--global-width);\n  max-width: calc(100vw - 2rem);\n  border-radius: var(--card-radius);\n  background-color: var(--sky-soft);\n  box-shadow: var(--shadow-float);\n  overflow: hidden;\n  margin: var(--card-margin) 0;\n}\n\n@media (max-width: 600px) {\n  :root {\n    --room-width: 100vw;\n  }\n\n  #webapp-root {\n    margin: 0;\n    max-width: unset;\n    border-radius: 0;\n    border: none;\n    box-shadow: none;\n    width: 100%;\n    min-height: 100vh;\n    min-height: 100dvh;\n  }\n}\n\n/* ---- Utilities ---- */\n\n.bold {\n  font-weight: 800;\n}\n\n.big {\n  font-size: 2.3rem;\n}\n\n.red {\n  color: var(--error-color);\n}\n\n.center {\n  text-align: center;\n}\n\n.flex {\n  display: flex;\n}\n\n.muted {\n  color: var(--ink-soft);\n}\n\n.logo {\n  height: 6rem;\n  margin: 0 1rem;\n}\n\n/* Small rounded status pill. */\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: var(--sky-strong);\n  color: var(--ink);\n  border-radius: var(--pill-radius);\n  padding: 0.35rem 1rem;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1rem;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.pill.light {\n  background: var(--white);\n}\n\n/* Big rounded status pill with \"> text <\" chevrons on both sides. */\n.chevrons {\n  display: inline-flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.chevrons::before,\n.chevrons::after {\n  content: \"\";\n  flex-shrink: 0;\n  width: 0.42em;\n  height: 0.42em;\n  border-top: max(2px, 0.11em) solid var(--ink);\n  border-right: max(2px, 0.11em) solid var(--ink);\n  opacity: 0.9;\n}\n\n.chevrons::before {\n  transform: rotate(45deg);\n}\n\n.chevrons::after {\n  transform: rotate(-135deg);\n}\n\n.statusPill {\n  background: var(--sky-strong);\n  color: var(--ink);\n  border-radius: var(--pill-radius);\n  padding: 0.5rem 1.4rem;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.3rem;\n  line-height: 1.2;\n  white-space: nowrap;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Circular initial badge for a player. */\n.avatar {\n  flex-shrink: 0;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: var(--sky-strong);\n  color: var(--ink);\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.2rem;\n  text-transform: uppercase;\n  line-height: 1;\n}\n\n.avatar.pink {\n  background: var(--pink-soft);\n}\n\n.avatar.team1 {\n  background: #5fc0f0;\n}\n\n.avatar.team2 {\n  background: #e86ca1;\n  color: var(--white);\n}\n\n.error {\n  font-size: 1.1rem;\n  position: absolute;\n  top: 5rem;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  color: var(--error-color);\n  text-align: center;\n}\n\n.error > span {\n  padding: 0.6rem 1.2rem;\n  border-radius: var(--border-radius);\n  background-color: var(--white);\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\n  display: inline-block;\n}\n\n.loadingSpinner {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 3rem solid var(--navy);\n  border-top-color: var(--pink);\n  border-bottom-color: var(--pink);\n  border-radius: 50%;\n  animation: loadingspin 1.4s linear infinite;\n  margin: 12rem auto 0;\n  left: 0;\n  right: 0;\n  z-index: 20;\n}\n\n@keyframes loadingspin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\ntextarea {\n  padding: 0.8rem 1rem;\n  min-width: 30rem;\n  min-height: 12rem;\n  font-family: var(--font-body);\n  font-size: var(--input-font-size);\n  font-weight: 600;\n  color: var(--font-color);\n  background: var(--white);\n  border: 2px solid var(--light-border-color);\n  border-radius: var(--border-radius);\n  margin-bottom: 0.4rem;\n  resize: vertical;\n}\n\n@media (max-width: 600px) {\n  textarea {\n    display: block;\n    box-sizing: border-box;\n    min-width: unset;\n    width: 100%;\n    height: 10rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
